export default "__VITE_ASSET__BQaCbRHq__"